import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useRouter } from 'next/navigation';

import { LaunchpoolStatus } from '@flipster/apis/v1/launchpool/types';
import Formatted from '@flipster/react/design-utils/formatted';
import DocumentHistoryIcon from '@flipster/react/icon/generated/DocumentHistoryIcon';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { css, cx } from '@flipster/styled-system/css';
import { center, hstack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import { alert } from '@flipster/utils/alert';
import { generateLinkWithQueryParams } from '@flipster/utils/url';

import { sparkLaunchpoolItemBunja } from './bunja';

const SparkTotalReward = () => {
  const router = useRouter();
  const { launchpoolItemAtom, isClosedAtom, rewardCurrencyPrecision } = useBunja(sparkLaunchpoolItemBunja);
  const isClosed = useAtomValue(isClosedAtom);
  const launchpool = useAtomValue(launchpoolItemAtom);
  const { id, rewardCurrency, estimatedReward, status, stakedAmount } = launchpool;
  const isShowLaunchpoolHistory = status !== LaunchpoolStatus.Upcoming && Number(stakedAmount) !== 0;
  return (
    <div className={css({ mt: 12, pos: 'relative' })}>
      <div>
        <button
          type='button'
          onClick={() =>
            router.push(generateLinkWithQueryParams('/history/launchpool-reward', { launchpoolId: String(id) }))
          }
          disabled={!isShowLaunchpoolHistory}
          className={center({
            pos: 'absolute',
            top: 0,
            right: 0,
            color: 'content.default.level-3',
            _disabled: { color: 'content.interaction.disabled' },
          })}
        >
          <DocumentHistoryIcon size={24} />
        </button>
        <div
          className={cx(
            css({
              display: 'flex',
              flexDirection: { base: 'column', tablet: 'row' },
              justifyContent: 'center',
              alignItems: { tablet: 'center' },
              gap: { base: 8, tablet: 12 },
              color: 'content.default.level-4',
            }),
            isClosed && css({ color: 'content.default.level-2' }),
          )}
        >
          <div className={hstack({ textStyle: 'Text/M/Strong', h: 24 })}>
            Your total reward
            <button type='button' onClick={alertYourTotalReward} className={css({ buttonShape: 'inline-icon', ml: 4 })}>
              <InformationCircleIcon size={16} color={token('colors.content.default.level-1')} />
            </button>
          </div>
          <div>
            <Formatted.Number
              value={estimatedReward}
              suffix={<span className={css({ textStyle: 'Text/M/Regular' })}>{rewardCurrency}</span>}
              precision={rewardCurrencyPrecision}
              zeroString='-'
              css={hstack.raw({
                textStyle: 'Title/S',
                justify: { tabletDown: 'flex-end' },
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SparkTotalReward;

function alertYourTotalReward() {
  alert.show({
    title: 'Your total reward',
    message: (
      <div className={css({ textStyle: 'Text/M/Regular' })}>
        Rewards are calculated proportional to your share of the total staked amount.
        <br />
        <br />
        Refreshed daily at 00:00 UTC.
        <br />
        There may be a delay of a few minutes.
      </div>
    ),
    confirmText: 'Dismiss',
  });
}
